export default __webpack_public_path__ + "static/media/octocat.dea49d48.png";